/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.offerings.create.policies.modals.email.controllers', [
  'ui.bootstrap',
  'acme.common.service.helpers'
])

.controller('MembershipOfferingsCreatePoliciesModalsEmailController', ['$scope', '$uibModalInstance', 'currentMessage', 'HelpersService', function($scope, $uibModalInstance, currentMessage, HelpersService) {

    $scope.membershipOfferingsCreatePoliciesModalsEmail = {

      model: '',
      lastCaretPosition: 0,
      initted: false,
      variables: [
        {
          label: 'Cardholder Name',
          name: '$membership.cardholderName',
          markup: "#if ($membership.cardholderName)\n\t$membership.cardholderName\n#end\n"
        },
        {
          label: 'Membership Level Name',
          name: '$membership.levelName',
          markup: "#if ($membership.levelName)\n\t$membership.levelName\n#end\n"
        },
        {
          label: 'Membership Offering Name',
          name: '$membership.offeringName',
          markup: "#if ($membership.offeringName)\n\t$membership.offeringName\n#end\n"
        },
        {
          label: 'Membership Price Point Name',
          name: '$membership.pricePointName',
          markup: "#if ($membership.pricePointName)\n\t$membership.pricePointName\n#end\n"
        },
        {
          label: 'Membership Price paid',
          name: '$membership.price',
          markup: "#if ($membership.price)\n\t$membership.price\n#end\n"
        },
        {
          label: 'Duration',
          name: '$membership.duration',
          markup: "#if ($membership.duration)\n\t$membership.duration\n#end\n"
        }
      ],

      init: function() {
        if (currentMessage) {
          this.model = currentMessage;
        }
      },

      insert: function(variable) {

        var textarea = $('#membership-offerings-create-policies-modals-email-textarea'),
            text = textarea.val(),
            insertText = variable + ' ';

        if (!this.initted && text.length && this.lastCaretPosition === 0) {
          this.lastCaretPosition = text.length - 1;
        }

        textarea.val(text.substr(0, this.lastCaretPosition) + insertText + text.substr(this.lastCaretPosition, text.length));
        this.lastCaretPosition += insertText.length;
        HelpersService.setCaretPosition(textarea, this.lastCaretPosition);

      },

      saveCaret: function() {

        var textarea = $('#membership-offerings-create-policies-modals-email-textarea');

        this.lastCaretPosition = HelpersService.getCaretPosition(textarea.get(0));
        this.initted = true;

      },

      done: function() {
        var textarea = $('#membership-offerings-create-policies-modals-email-textarea');
        this.model = textarea.val();
        $uibModalInstance.close(this.model);
      },

      cancel: function() {
        $uibModalInstance.dismiss('cancel');
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.membershipOfferingsCreatePoliciesModalsEmail.init();

}]);